import { forwardRef } from "react";
import { clsx } from "clsx";
import { useRadioProps } from "./useRadioProps";
import classes from "./Radio.module.scss";
import { RadioImageProps } from "./RadioImageProps";
import { CheckCircle } from "../Icon/CheckCircle";

export const RadioImage = forwardRef<HTMLInputElement, RadioImageProps>(
  function RadioImage(
    props: RadioImageProps,
    inputRef: React.Ref<HTMLInputElement>,
  ) {
    const {
      className,
      id,
      image,
      alt = "",
      ...inputProps
    } = useRadioProps<RadioImageProps>(props);

    return (
      <label className={clsx(classes.imageLabel, className)} htmlFor={id}>
        <div className={classes.imageWrap}>
          <img src={image} alt={alt} className={classes.image} />
        </div>

        <input
          type="radio"
          ref={inputRef}
          className={classes.hiddenInput}
          id={id}
          {...inputProps}
        />

        <CheckCircle
          size={24}
          color="currentColor"
          className={classes.checkIcon}
        />
      </label>
    );
  },
);
